import { useEffect } from "react";

const ScrollToHash = () => {
    useEffect(() => {
        if (window.location.hash) {
            const id = window.location.hash.replace("#", "");
            const el = document.getElementById(id);

            if (el) {
                setTimeout(() => {
                    el.scrollIntoView({ behavior: "smooth" });
                }, 50); // delay so the DOM finishes rendering
            }
        }
    }, []);

    return null;
};

export default ScrollToHash;
